import http from "../../backend/http.js";

async function getProductReceipt(id) {
  try {
    const response = await http.get(`sales/product-receipts/${id}`);
    return {
      id: response.data.id,
      date: response.data.date,
      client: {
        id: response.data.client.id,
        title: response.data.client.title,
      },
      product: {
        id: response.data.product.id,
        title: response.data.product.title,
      },
      price: response.data.price,
      amount: response.data.amount,
      totalPrice: response.data.totalPrice,
      user: {
        id: response.data.user.id,
        title: response.data.user.title,
      },
      description: response.data.description,
    };
  } catch (err) {
    throw err;
  }
}

async function updateProductReceipt(id, data) {
  try {
    const response = await http.put(`sales/product-receipts/${id}`, data);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createProductReceipt(data) {
  try {
    const response = await http.post("sales/product-receipts", data);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getProductReceipts(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = ""
) {
  try {
    const response = await http.get(
      `sales/product-receipts?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

export { getProductReceipt, updateProductReceipt, getProductReceipts, createProductReceipt };